(() => {
  // Style einmalig injizieren
  function injectStyleOnce() {
    if (document.getElementById('addon-notice-style')) return;
    const style = document.createElement('style');
    style.id = 'addon-notice-style';
    style.textContent = `
      .addon-notice {
        position: relative;
        background: #fffdf5;
        border: 1px solid #f2e3b3;
        border-radius: 6px;
        padding: 10px 14px;
        margin: 10px 0;
        font-size: 14px;
        color: #4a3d00;
        box-shadow: 0 2px 6px rgba(0,0,0,0.05);
        display: none;
        opacity: 0;
        transform: translateY(-6px);
        transition: opacity 0.35s ease, transform 0.35s ease;
      }

      .addon-notice.visible {
        display: block;
        opacity: 1;
        transform: translateY(0);
      }

      .addon-notice.fade-out {
        opacity: 0;
        transform: translateY(-6px);
      }

      .addon-notice__close {
        position: absolute;
        top: 8px;
        right: 10px;
        border: none;
        background: none;
        font-size: 16px;
        line-height: 1;
        cursor: pointer;
        color: #4a3d00;
        padding: 0;
        opacity: 0.6;
        transition: opacity 0.2s;
      }

      .addon-notice__close:hover {
        opacity: 1;
      }

      .addon-notice__text {
        display: block;
        margin-right: 24px;
      }
    `;
    document.head.appendChild(style);
  }

  function findCartContainer() {
    const selectors = [
      '.cart-drawer__items',
      'cart-drawer .drawer__inner',
      '.cart-items',
      '.cart__items',
      '#CartDrawer .drawer__inner'
    ];
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return document.querySelector('main, body');
  }

  function createNotice(message) {
    injectStyleOnce();
    const container = findCartContainer();
    if (!container) return;

    const box = document.createElement('div');
    box.className = 'addon-notice';
    box.innerHTML = `
      <button class="addon-notice__close" type="button" aria-label="Hinweis schließen">&times;</button>
      <span class="addon-notice__text">${message}</span>
    `;

    container.parentNode
      ? container.parentNode.insertBefore(box, container)
      : container.prepend(box);

    box.querySelector('.addon-notice__close')
      ?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        fadeOutAndRemove(box);
      });

    requestAnimationFrame(() => box.classList.add('visible'));

    // Automatisches Fade-Out nach 8s
    setTimeout(() => fadeOutAndRemove(box), 8000);
  }

  function fadeOutAndRemove(box) {
    box.classList.remove('visible');
    box.classList.add('fade-out');
    setTimeout(() => box.remove(), 350); // Dauer = transition Zeit
  }

  window.showAddonNotice = createNotice;

  document.addEventListener("DOMContentLoaded", () => {
    if (localStorage.getItem('addonNotice') === 'true') {
      localStorage.removeItem('addonNotice');
      setTimeout(() => createNotice("Zusatzgeschenke sind nur in gleicher Anzahl wie physische Gutscheine möglich. Geschenkboxen sind ausgenommen. Überzählige Artikel wurden entfernt."), 400);
    }

    if (localStorage.getItem('envelopeNotice') === 'true') {
      localStorage.removeItem('envelopeNotice');
      setTimeout(() => createNotice("Der Geschenkumschlag mit personalisierter Handschrift ist nur einzeln mit Gutschein bestellbar. Der Artikel wurde daher entfernt."), 800);
    }
  });
})();